import { ReactNode, useEffect, useRef, useState } from "react";
import {
	addVisibleLink,
	getCurrentActive,
	removeVisibleLink,
} from "./waypoint";
import { useTranslation } from "react-i18next";

interface IMenuItemWaypoint {
	link?: string | null;
	label: string;
	navItem: ReactNode;
	onClick?(): void;
}

export const MenuItemWaypoint = ({
	link,
	navItem,
	label,
	onClick,
}: IMenuItemWaypoint) => {
	const itemRef = useRef<HTMLDivElement>(null);
	const [currentActiveItem, setCurrentActiveItem] = useState("");
	const {
		t,
		i18n: { language },
	} = useTranslation();
	useEffect(() => {
		function checkViewport(init?: boolean) {
			const elm = link ? document.getElementById(link) : itemRef.current;

			if (!elm) {
				console.error(`Waypoint Element not found for: ${link}`);
				return;
			}

			const rect = elm.getBoundingClientRect();
			const isVisible = rect.top < 10;

			if (isVisible) {
				if (itemRef.current) {
					addVisibleLink({
						id: link || "",
						pos: rect.top,
						ref: itemRef.current,
					});
				}
			} else {
				removeVisibleLink(link || "");
			}

			/**
			 * Timeout to collect all waypoints
			 * after that, check the current active
			 */
			setTimeout(() => {
				const currentActive = getCurrentActive();
				setCurrentActiveItem(currentActive);
				if (
					!init &&
					window.location.hash !== "#" + currentActive &&
					currentActive !== window.location.hash
				) {
					history.replaceState({}, "", "#" + currentActive);
				}
			}, 1);
		}

		/**
		 * Initial timeout to make sure anchor is in dom
		 */
		setTimeout(() => {
			checkViewport(true);
			document.addEventListener("scroll", checkViewport.bind(this, false));
		}, 500);

		return () => {
			document.removeEventListener("scroll", checkViewport.bind(this, false));
		};
	}, [link]);

	useEffect(() => {
		trackPageScroll();
	}, [currentActiveItem]);

	const trackPageScroll = () => {
		try {
			const path =
				 document.location.pathname + currentActiveItem.slice(1);

			window.ste_statistic = window.ste_statistic || [];
			window.ste_statistic.push({
				action: "page.scroll",
				data: {
					page: {
						country:"WW",
						path: path,
						language,
					},
				},
			});
		} catch (error) {
			console.warn("Tracking fail");
		}
	};

	return (
		<div ref={itemRef} data-waypoint>
			<a
				className={currentActiveItem === link ? "active" : ""}
				onClick={(e) => {
					onClick && onClick();
					e.preventDefault();

					const el = document?.getElementById(`${link}`);
					if (el) {
						window.scrollTo({
							behavior: "smooth",
							top:
								el.getBoundingClientRect().top -
								document.body.getBoundingClientRect().top,
						});
					}
				}}
				aria-label={label}
			>
				{navItem}
			</a>
		</div>
	);
};
